import React from 'react'
import styled from 'react-emotion'
import {
  mediaDn,
  padding,
  spacer,
  typography,
  ExternalButtonLink
} from 'stylist'

const Container = styled.article`
  ${padding('md')};
  flex-basis: 50%;
  max-width: 50%;
  margin-bottom: ${spacer(4)};

  ${mediaDn('md')} {
    flex-basis: unset;
    max-width: none;
  }

  @supports (display: grid) {
    flex-basis: unset;
    max-width: none;
    margin-bottom: 0;
  }
`

const Description = styled.p`
  margin-bottom: ${spacer(4)};
  ${typography('body2')};
`

const PlatformEntry = ({ entry }) => (
  <Container>
    <h5>{entry.title}</h5>
    <Description>{entry.description}</Description>
    <ExternalButtonLink kind="standard" href={entry.link}>
      {entry.linkText}
    </ExternalButtonLink>
  </Container>
)

export default PlatformEntry



// WEBPACK FOOTER //
// ./src/routes/home/components/PlatformEntry.js